export default __webpack_public_path__ + "static/media/howtouse_img_02.79e57925.svg";